import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPlus, FiUsers, FiCalendar, FiBarChart3 } = FiIcons;

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Add Medicine',
      description: 'Add a new medicine to your schedule',
      icon: FiPlus,
      color: 'blue',
      onClick: () => navigate('/medicines/add')
    },
    {
      title: 'Family Access',
      description: 'Manage family member permissions',
      icon: FiUsers,
      color: 'green',
      onClick: () => navigate('/family')
    },
    {
      title: 'Schedule',
      description: 'View your complete medicine schedule',
      icon: FiCalendar,
      color: 'purple',
      onClick: () => navigate('/schedule')
    },
    {
      title: 'Reports',
      description: 'View detailed analytics and reports',
      icon: FiBarChart3,
      color: 'orange',
      onClick: () => navigate('/reports')
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700',
      green: 'from-green-500 to-green-600 hover:from-green-600 hover:to-green-700',
      purple: 'from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700',
      orange: 'from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700'
    };
    return colors[color];
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
      <h2 className="text-xl font-bold text-gray-900 mb-6">Quick Actions</h2>
      
      <div className="space-y-4">
        {actions.map((action, index) => (
          <motion.button
            key={action.title}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            whileHover={{ scale: 1.02, x: 5 }}
            whileTap={{ scale: 0.98 }}
            onClick={action.onClick}
            className={`w-full p-4 rounded-xl bg-gradient-to-r ${getColorClasses(action.color)} text-white text-left transition-all duration-200 shadow-sm hover:shadow-md`}
          >
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                <SafeIcon icon={action.icon} className="text-xl" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold">{action.title}</h3>
                <p className="text-sm opacity-90">{action.description}</p>
              </div>
            </div>
          </motion.button>
        ))}
      </div>

      {/* Today's Summary */}
      <div className="mt-8 p-4 bg-gray-50 rounded-xl">
        <h3 className="font-semibold text-gray-900 mb-3">Today's Summary</h3>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Medicines taken</span>
            <span className="font-medium text-green-600">5 of 8</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Next dose</span>
            <span className="font-medium text-blue-600">2:00 PM</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Adherence rate</span>
            <span className="font-medium text-purple-600">92%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;